import {
  FETCH_ACTION_HISTORY_LIST_FILTER,
  RESET_ACTION_HISTORY_LIST_FILTER,
  FETCH_ACTION_HISTORY_LIST_CHIP_FILTER,
} from "../../constants/action.constants";

const initialState = {
  filters: {},
  chipFilters: [],
};

const actionHistoryListFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ACTION_HISTORY_LIST_FILTER:
      return {
        ...state,
        filters: action.payload,
      };

    case FETCH_ACTION_HISTORY_LIST_CHIP_FILTER:
      return {
        ...state,
        chipFilters: action.payload,
      };

    case RESET_ACTION_HISTORY_LIST_FILTER:
      return initialState;

    default:
      return state;
  }
};

export default actionHistoryListFilterReducer;
